import { LOCAL_STORAGE_KEYS } from './local-storage-keys'
import { SESSION_STORAGE_KEYS } from './session-storage-keys'

export const KEYS = Object.assign({}, LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS)
